import {
  DxAccordionModule,
  DxBarGaugeModule,
  DxButtonModule,
  DxCalendarModule,
  DxChartModule,
  DxCheckBoxModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxDateRangeBoxModule,
  DxDropDownBoxModule,
  DxFileUploaderModule,
  DxFormModule,
  DxListModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxLookupModule,
  DxNumberBoxModule,
  DxPieChartModule,
  DxPopupModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxSliderModule,
  DxSwitchModule,
  DxTabPanelModule,
  DxTabsModule,
  DxTagBoxModule,
  DxTextBoxModule,
  DxTreeListModule,
  DxValidationGroupModule,
  DxValidationSummaryModule,
  DxValidatorModule,
  DxVectorMapModule,
} from "devextreme-angular";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SafePipe } from "@app/core/pipes/safe.pipe";
import { SharedGetFilesComponent } from "@app/shared/components/get-files/shared-get-files.component";
import { SharedLogTableComponent } from "@app/shared/components/log-table/shared-log-table.component";
import { NgxLoadingModule } from "ngx-loading";
import { ToastrModule } from "ngx-toastr";
import { FilterPhotoReportComponent } from "./components/filter-photo-report/filter-photo-report.component";
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { ImageCropperComponentTR } from "./components/image-cropper/image-cropper.component";

import { RouterModule } from "@angular/router";
import { PhonePipe } from "@app/core/pipes/phone.pipe";
import {
  GenComponentDirective,
  ScrollIntoViewDirective,
} from "@app/core/directives";
import { WorkingDaysComponent } from "./components/working-days/working-days.component";
import { ShortFioPipe } from "@app/core/pipes/short-fio.pipe";
import { SlimScrollDirective } from "@app/core/directives/slim-scroll.directive";
import { TimeTextPipe } from "@app/core/pipes/time-text.pipe";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconazerComponent } from "./components/iconazer/iconazer.component";
import { DropDownWithTagsComponent } from "./components/drop-down-with-tags/drop-down-with-tags.component";
import { StoreDraggableComponent } from "./components/store-draggable/store-draggable.component";
import { TranslateModule } from "@ngx-translate/core";
import { RemoveCommaPipe } from "@app/core/pipes/remove-comma.pipe";
import { StringToDatePipe } from "@app/core/pipes/string-to-date.pipe";
import { AppDatePipe } from "@app/core/pipes/app-date.pipe";
import { SwitcherComponent } from "./components/switcher/switcher.component";
import { DatePickerComponent } from "./components/date-picker/date-picker.component";
import { DatePickerIntervalComponent } from "./components/date-picker-interval/date-picker-interval.component";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { DatePickerAdvancedComponent } from "./components/date-picker-advanced/date-picker-advanced.component";
import { ImageCropperComponent } from "ngx-image-cropper";
import { AppIconComponent } from "@app/shared/components/app-icon/app-icon.component";
import { DatePickerIconComponent } from "@app/shared/components/date-picker-icon/date-picker-icon.component";
import { UiCheckboxComponent } from "@app/shared/components/ui-checkbox/ui-checkbox.component";
import { CheckboxComponent } from "@app/shared/components/checkbox/checkbox.component";
import { CalendarComponent } from "@app/shared/components/calendar/calendar.component";
import { DateRangeInputComponent } from "@app/shared/components/date-range-input/date-range-input.component";
import { DateInputComponent } from "@app/shared/components/date-input/date-input.component";
import { DateInputFormComponent } from "@app/shared/components/date-input-form/date-input-form.component";
import { ResizeDirective } from "@app/core/directives/observe-resize.directive";
import { ConfirmDialogModernComponent } from "@app/shared/components/confirm-dialog-modern/confirm-dialog-modern.component";
import { ModernTabsComponent } from "@app/shared/components/modern-tabs/modern-tabs.component";
import { ReactiveFormsModule } from "@angular/forms";
import { TimeInputFormComponent } from "@app/shared/components/time-input-form/time-input-form.component";
import { TimePickerComponent } from "@app/shared/components/time-input-form/time-picker/time-picker.component";

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    DxVectorMapModule,
    DxBarGaugeModule,
    DxListModule,
    DxDropDownBoxModule,
    DxAccordionModule,
    DxButtonModule,
    DxChartModule,
    DxTextBoxModule,
    DxTabPanelModule,
    DxPieChartModule,
    DxDataGridModule,
    DxPopupModule,
    DxTreeListModule,
    DxNumberBoxModule,
    DxFileUploaderModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxFormModule,
    DxTagBoxModule,
    DxLookupModule,
    DxLoadIndicatorModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxValidationGroupModule,
    NgxLoadingModule,
    ToastrModule,
    DxTabsModule,
    DxLoadPanelModule,
    RouterModule,
    DxSwitchModule,
    DxCalendarModule,
    DxScrollViewModule,
    TranslateModule,
    DxSliderModule,
    DxDateRangeBoxModule,
    DxFormModule,
    ImageCropperComponent,
    UiCheckboxComponent,
    ResizeDirective,
    ReactiveFormsModule,
  ],
  exports: [
    CommonModule,
    FontAwesomeModule,
    DxVectorMapModule,
    DxBarGaugeModule,
    DxListModule,
    DxDropDownBoxModule,
    DxAccordionModule,
    DxButtonModule,
    DxChartModule,
    DxTextBoxModule,
    DxTabPanelModule,
    DxPieChartModule,
    DxDataGridModule,
    DxPopupModule,
    DxTreeListModule,
    DxNumberBoxModule,
    DxFileUploaderModule,
    SharedLogTableComponent,
    SharedGetFilesComponent,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxTagBoxModule,
    DxLookupModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxValidationGroupModule,
    SafePipe,
    PhonePipe,
    RemoveCommaPipe,
    ShortFioPipe,
    TimeTextPipe,
    NgxLoadingModule,
    ToastrModule,
    DxTabsModule,
    DxLoadPanelModule,
    FilterPhotoReportComponent,
    DxSwitchModule,
    GenComponentDirective,
    SlimScrollDirective,
    WorkingDaysComponent,
    DxCalendarModule,
    IconazerComponent,
    DropDownWithTagsComponent,
    StoreDraggableComponent,
    DxScrollViewModule,
    TranslateModule,
    DxSliderModule,
    StringToDatePipe,
    AppDatePipe,
    SwitcherComponent,
    DatePickerComponent,
    DatePickerIntervalComponent,
    DxDateRangeBoxModule,
    PaginationComponent,
    DxFormModule,
    DatePickerAdvancedComponent,
    // expose icon component so it can be used in layouts/templates
    AppIconComponent,
    DatePickerIconComponent,
    UiCheckboxComponent,
    CheckboxComponent,
    CalendarComponent,
    DateRangeInputComponent,
    DateInputComponent,
    DateInputFormComponent,
    ResizeDirective,
    ModernTabsComponent,
    TimeInputFormComponent,
    TimePickerComponent,
  ],
  declarations: [
    SharedLogTableComponent,
    SharedGetFilesComponent,
    SafePipe,
    PhonePipe,
    StringToDatePipe,
    AppDatePipe,
    RemoveCommaPipe,
    ShortFioPipe,
    TimeTextPipe,
    FilterPhotoReportComponent,
    ConfirmDialogComponent,
    ConfirmDialogModernComponent,
    ImageCropperComponentTR,
    GenComponentDirective,
    SlimScrollDirective,
    WorkingDaysComponent,
    WorkingDaysComponent,
    IconazerComponent,
    DropDownWithTagsComponent,
    StoreDraggableComponent,
    SwitcherComponent,
    DatePickerComponent,
    DatePickerIntervalComponent,
    PaginationComponent,
    DatePickerAdvancedComponent,
    AppIconComponent,
    DatePickerIconComponent,
    CheckboxComponent,
    CalendarComponent,
    DateRangeInputComponent,
    DateInputComponent,
    ScrollIntoViewDirective,
    DateInputFormComponent,
    ModernTabsComponent,
    TimeInputFormComponent,
    TimePickerComponent,
  ],
})
export class DxSharedModule {}
